document.addEventListener('UPEZ_CART_CLOSED', () => {
  // Remove upnova's incorrect overflow value

  document.documentElement.style.overflow = '';
});
